<template>
	<el-drawer
		id="configuraciones"
		size="50%"
		:title="title"
		:visible="show"
		:show-close="false"
		direction="rtl"
		:close-on-press-escape="false"
		@close="onClosed"
	>
		<el-tree
			:data="modulos"
			node-key="id"
			default-expand-all
			:draggable="user.length !== 0 ? false : true"
			:expand-on-click-node="false"
			:render-content="renderContent"
			@check-change="handleCheckChange"
		>
		</el-tree>
		<template slot="footer">
			<el-button @click="show = false" :disabled="!closable">Cerrar</el-button>
			<el-button @click="callaxios()" type="primary" size="mini" :loading="guardando" icon="el-icon-linear-floppy-disk">
				Guardar
			</el-button>
		</template>
	</el-drawer>
</template>
<script lang="js">
export default {
	name: 'configuraciones',
	props: {
		visible: {
			type: Boolean,
			required: true,
			default: false
		},
		user:{
			type: Array
		},
		total:{
			type: Number
		},

	},
	data() {
		return {
			closable: true,
			modulos :[],
			rango :[],
			guardando: false,
			show: false,
			titleCheck: 'La configuración que establezca en éste panel es la que le quedará a cada uno de los usuarios seleccionados, para agregar sólo los módulos seleccionados habilite "sólo seleccionados".',
			title:'',
			desde:'',
			hasta:'',
			arrayUser:[],
			checked: false,
			pickerOptions: {
				disabledDate: this.disabledDueDate
			},
			defaultProps: {
				children: 'children',
				label: 'nombre'
			}
		}
	},
	watch:{
		visible(v) {
			this.arrayUser = [];
			this.user.forEach(element => {
				this.arrayUser.push(element.username)
			});
			this.loadModulos();
			this.title =  'Configuraciones para la empresa';
			this.show = !this.show;
		},
	},
	methods:{
		disabledDueDate(date) {
			if (this.user) return (new Date(this.hasta) < date || date < new Date(this.desde));
		},
		focusDateChange(data){
			this.desde = data.empresa_fecha_desde;
			this.hasta = data.empresa_fecha_hasta;
		},
		handleDateChange(data,desde, hasta){
			data.fecha_desde = null;
			data.fecha_hasta = null;
			if (data.rango){
				data.fecha_desde = data.rango[0];
				data.fecha_hasta = data.rango[1];
			}
		},
		handleSwitchChange(data){
			if (data.mobile || data.desktop){
				this.modulos.forEach(element => {
					if (element.children){
						element.children.forEach(element2 => {
							if (element2.id == data.id){
								if (data.desktop) element.desktop = true;
								if (data.mobile) element.mobile = true;
							}
						});
					}
				});
			}
		},
		handleCheckChange(data, checked, indeterminate) {
			indeterminate ? (data.mobile = true,data.desktop = true):(data.mobile = true,data.desktop = true)
		},
		renderContent(h, { node, data, store }) {
			return (
				<span class="custom-tree-node">
					<i style= "padding-right:10px" class={data.icono}></i>
					<div style= "width:40%">{data.nombre}</div>
					<div class="content">
						<i  style= "padding: 0px 10px" class="el-icon-mobile-phone"><el-switch disabled={(typeof data.empresa_mobile!== 'undefined')?!data.empresa_mobile: false} v-model={data.mobile} on-change={ () =>this.handleSwitchChange(data)}></el-switch></i>
						<i  style= "padding: 0px 10px" class="el-icon-monitor"><el-switch disabled={(typeof data.empresa_desktop!== 'undefined')?!data.empresa_desktop:false} v-model={data.desktop} on-change={ () =>this.handleSwitchChange(data)}></el-switch></i>
						<span style={data.style}>
							<el-date-picker
								v-show="false"
								v-model={data.rango}
								style= "padding: 0px 10px"
								type="daterange"
								start-placeholder="Desde"
								end-placeholder="Hasta"
								format= "dd/MM/yyyy"
								disabled={!(data.mobile || data.desktop)}
								picker-options={this.pickerOptions}
								on-change={ () =>this.handleDateChange(data, data.fecha_desde, data.fecha_hasta)}
								on-focus={ () => this.focusDateChange(data)}
								>
							</el-date-picker>
						</span>
					</div>
				</span>
			);
	 	},

		callaxios() {
			var axios;
			(this.user.length !== 0) ? axios = this.$axios.put(`./api/public/configuraciones/${this.user[0].username}`, this.modulos ): axios = this.$axios.post('./api/public/configuraciones', this.modulos);
			this.guardando = true;
			axios.then(response => {
				if (!response.data.success) {
					this.$message({
						type: 'error',
						showClose: true,
						message: response.data.msg,
					});
				} else {
					if (response.data.warning) {
						this.$message({
							type: 'warning',
							showClose: true,
							message: response.data.msg,
						});
					} else {
						this.$message({
							type: 'success',
							message: response.data.msg,
						});
					}
				}
				this.guardando = false;
				this.show = false;
			})
			.catch(error => {
				this.$message({
					type: 'error',
					message: 'Error al guardar los módulos para la empresa',
				});
				this.guardando = false;
				this.show = false;
			});
		},
		loadModulos() {
			var url;
			(this.user.length !== 0) ? url = `./api/public/configuraciones/${this.user[0].username}` : url = './api/public/configuraciones';
			this.$axios
				.get(url)
				.then(response => {
					this.modulos = response.data.menu;
				})
				.catch(error => {
					this.$notify.error({
						title: 'Error',
						message: 'Error al cargar datos',
						position: 'top-right',
					});
				})
		},
		onClosed() {
			if (this.closable)
				this.show = false;

		},
	},
	mounted() {}
};
</script>
<style>
.custom-tree-node {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 15px;
	padding-right: 15px;
}
.el-tree-node__content {
	padding: 10px;
}
.custom-tree-node.el-input__inner {
	font-size: 10px;
	width: 50% !important;
	height: 30px !important;
	line-height: 30px !important;
}
.el-message-box__wrapper {
	z-index: 100007 !important;
}
</style>
